export default "__VITE_ASSET__C_W7kMxm__"